import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { eliteDealsAssets } from "assets/cdn";
import { Navigation } from "interfaces/navigation";
import { useLocation, useNavigate } from "react-router-dom";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import {
	ClubShopIcon,
	CrownIcon,
	NewsIcon,
	ShopIcon,
	DailyGiftIcon,
	ClubGiftIcon,
	PoisBountyIcon,
	DripOfferIcon,
	FriendCenterIcon,
	EliteDealsIcon
} from "utils/svgIcons";
import { TopBarButton } from "components/PageTopNavV2/styled";
import { isPageActive } from "helpers/isPageActive";
import { useImagePath } from "hooks/useImagePath";

interface Props {
	page: Navigation;
}

export const MenuOption: React.FC<Props> = ({ page }) => {
	const location = useLocation();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const navigate = useNavigate();
	const { getImage } = useImagePath("cdn");
	const isActive = isPageActive(location.pathname, page);
	const isEliteDeals = page.icon === "elite-deals";
	const eliteBackgroundImage = getImage(eliteDealsAssets.buttonBackground);
	const hasReportedVipShopTabRender = useRef(false);

	const buttonClassName = classNames(
		isEliteDeals ? "elite-deals" : "default-nav",
		{ "is-active": isActive }
	);

	useEffect(() => {
		if (!isEliteDeals || hasReportedVipShopTabRender.current) {
			return;
		}

		hasReportedVipShopTabRender.current = true;
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "vip_shop_render",
			event_type: "vip_shop_tab",
			action: "tab_rendered",
			source: "vip_shop"
		});
	}, [isEliteDeals, reportPlaygamiEvent]);

	const onClick = (page: Navigation) => {
		reportEvent(page.analytics_key, { source: "navbar" });
		navigate(page.path);
	};

	return (
		<TopBarButton
			id={`page-top-nav-main-menu-${page.icon}`}
			className={buttonClassName}
			$tabBackgroundImage={isEliteDeals ? eliteBackgroundImage : undefined}
			onClick={() => onClick(page)}
		>
			{page.icon === "store" && <ShopIcon />}
			{page.icon === "club" && <ClubShopIcon />}
			{page.icon === "crown" && <CrownIcon />}
			{page.icon === "news" && <NewsIcon />}
			{page.icon === "daily-gift" && <DailyGiftIcon />}
			{page.icon === "club-gift" && <ClubGiftIcon />}
			{page.icon === "pois-bounty" && <PoisBountyIcon />}
			{page.icon === "drip-offer" && <DripOfferIcon />}
			{page.icon === "friend-center" && <FriendCenterIcon />}
			{page.icon === "elite-deals" && <EliteDealsIcon />}
			<span>{page.title}</span>
		</TopBarButton>
	);
};
